qw-basket-summary-responsive {
  display: block;
  width: 100%;
  height: auto;
}
